import { hexToRgbArray } from '../utils/color';
import { fabricToPdfCoords } from '../utils/coordinateUtils';

/**
 * Convert Fabric Ellipse to PDF Circle annotation
 */
export function fabricEllipseToPdfCircle({
  page,
  fabricObject,
  basePageDimensions: { width, height },
  user_full_name,
}) {
  const { strokeWidth, stroke } = fabricObject;
  const box = fabricObject.getBoundingRect(true, true);

  const x1 = box.left;
  const y1 = box.top;
  const x2 = box.left + box.width;
  const y2 = box.top + box.height;

  const pdfCoords = fabricToPdfCoords({
    x1,
    y1,
    x2,
    y2,
    page,
    width,
    height,
  });

  page.node.addAnnot(
    page.doc.context.obj({
      Type: 'Annot',
      Subtype: 'Circle',
      Rect: pdfCoords.rect,

      C: hexToRgbArray(stroke),
      CA: 1,
      F: 0,
      BS: { W: strokeWidth },

      T: user_full_name,
    })
  );
}
